<template>
  <div class="radar-header-card">
    <div class="stat-item">
      <div class="stat-label">库中总词数</div>
      <div class="stat-value">{{ workbench.amazon.keywordVolumeData.length }}</div>
    </div>

    <div class="stat-item">
      <div class="stat-label">高转化潜力词</div>
      <div class="stat-value color-gold">{{ workbench.hotKeywordsCount }}</div>
    </div>

    <div class="radar-actions">
      <button class="primary-btn compact" :disabled="workbench.amazon.loadingVolume" @click="workbench.analyzeTrafficAll">
        {{ workbench.amazon.loadingVolume ? '正在同步全球数据...' : '同步最新热搜度' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>
